import React from 'react';

import { BsBatteryCharging } from 'react-icons/bs';
import {TiGroupOutline} from 'react-icons/ti';
import {GiMusicalScore} from 'react-icons/gi';
import {HiAnnotation} from 'react-icons/hi';
import {GrWorkshop} from 'react-icons/gr';
import {GiFireFlower} from 'react-icons/gi';
const iconStyle = (Icon) => <Icon size="3rem" color="#0f0f0f" />;

export const featuresData = [
	{
		name: 'Musikalisches Verständnis',
		description: 'Mit über 30 Jahren Erfahrung als Dirigent und noch länger als Musiklehrer sorgt Andreas Reiss für ein optimales Klangerlebnis!',
		icon: iconStyle(GiMusicalScore),
		imgClass: 'one',
	},
	{
		name: 'Persönliche Absprache',
		description: 'Wir richten uns nach Ihren Wünschen oder liefern Vorschläge zur musikalischen Gestaltung.',
		icon: iconStyle(HiAnnotation),
		imgClass: 'two',
	},
	{
		name: 'Jugendarbeit',
		description: 'Wir unterstützen unsere Neulinge in ihrer musikalischen Ausbildung und stellen einen Mentor zur Verfügung.',
		icon: iconStyle(GrWorkshop),
		imgClass: 'three',
	},
	{
		name: 'Motiviertes Team',
		description: 'Wir geben immer unser Bestes! Nicht nur musikalisch…',
		icon: iconStyle(BsBatteryCharging),
		imgClass: 'four',
	},
	{
		name: 'Gemeinschaft',
		description: 'schreiben wir groß! Nicht nur in den Proben, sondern auch bei Arbeitseinsätzen und Ausflügen.',
		icon: iconStyle(TiGroupOutline),
		imgClass: 'five',
	},
	{
		name: 'Nachhaltigkeit',
		description:
			'ist uns wichtig! Wir vermeiden Einweggeschirr, Plastik und Co. bei unseren Veranstaltungen - weil uns unsere Umwelt am Herzen liegt!',
		icon: iconStyle(GiFireFlower),
		imgClass: 'six',
	},
];